import { createRouter, createWebHistory } from "vue-router";
// import { createRouter, createWebHashHistory } from "vue-router";
import MainRouter from "./modules/main";
import BookRouter from "./modules/book";
//
export const completeRoutes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
    hidden: true,
  },
];

export const constantRoutes = [...MainRouter, ...BookRouter];

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHashHistory(),
  routes: constantRoutes,
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
